// Small formatters for the Salesforce object list and network — nulls are meaningful here:
// a null record count is an object Salesforce does not track in /limits/recordCount, and a
// null size is "no estimate", never zero.

export function formatRecords(n) {
  if (n == null) return 'not tracked';
  const v = Number(n);
  if (!Number.isFinite(v)) return 'not tracked';
  return v.toLocaleString();
}

export function formatStorage(bytes) {
  if (bytes == null) return '—';
  const n = Number(bytes);
  if (!Number.isFinite(n) || n < 0) return '—';
  if (n >= 1024 * 1024 * 1024) return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  if (n >= 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  if (n >= 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${n} B`;
}

export const EDGE_KIND_TEXT = { LOOKUP: 'LOOKUP', MASTER_DETAIL: 'MASTER-DETAIL', MANUAL: 'MANUAL', FK: 'FK', INFERRED: 'INFERRED' };
export const edgeKindText = (kind) => EDGE_KIND_TEXT[kind] || kind || '';
